export default __webpack_public_path__ + "static/media/48d6a2322ae48b4797de9cdc55b66313.5a4f7848.png";